var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position-relative p-3 p-md-0"},[_c('div',{staticClass:"tl_content h-100 text-white p-3 p-md-5"},[_c('tab-widget',{attrs:{"activeClass":"gis_active"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }